<script lang="ts" setup>
interface IGenericSkeletonProps {
  widthClass?: string;
  heightClass?: string;
  roundedClass?: string;
}

withDefaults(defineProps<IGenericSkeletonProps>(), {
  widthClass: 'w-full',
  heightClass: 'h-full',
  roundedClass: 'rounded-xl',
});
</script>
<template>
  <div
    :class="[
      'animate-pulse dark:bg-dark-800 bg-light-400',
      heightClass,
      widthClass,
      roundedClass,
    ]"
  />
</template>
